import { render, staticRenderFns } from "./AssessmentsScreen.vue?vue&type=template&id=09e243ba&"
import script from "./AssessmentsScreen.vue?vue&type=script&lang=js&"
export * from "./AssessmentsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports